import { BsEyeFill } from "react-icons/bs"
import './Icons.scss'
export function IconEye(props:{onClick:Function}){
        return(
            <span className={'icon inline eye'} onClick={()=>{props.onClick()}}>
                <BsEyeFill />
            </span>
        )
    }